export default [
  { id: 0, description: "None" },
  { id: 1, description: "Before" },
  { id: 2, description: "After" },
  { id: 3, description: "Before and After" },
];
